import type { StoreApi, UseBoundStore } from 'zustand';
import { getCurrencyByCode } from '@/config/currencies';
import { safeLocalStorage } from '@/lib/browser/safe-local-storage';
import { getCookie } from '@/lib/config/cookies';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface CurrencyState {
  currency: string;
  setCurrency: (code: string) => void;
}

function getPersistedCurrency(): string {
  if (typeof window === 'undefined') return 'USD';
  // Explicit user choice takes priority
  const stored = safeLocalStorage.getItem('preferred-currency');
  if (stored !== null && stored.length > 0) {
    if (getCurrencyByCode(stored) !== undefined) return stored;
    safeLocalStorage.removeItem('preferred-currency');
  }
  // Fall back to IP-detected currency from middleware cookie
  const detected = getCookie('DETECTED_CURRENCY');
  if (detected !== undefined && detected.length > 0) {
    if (getCurrencyByCode(detected) !== undefined) return detected;
  }
  return 'USD';
}

export const useCurrencyStore: UseBoundStore<StoreApi<CurrencyState>> =
  createTrackedStore<CurrencyState>('useCurrencyStore')((set) => ({
    currency: getPersistedCurrency(),
    setCurrency: (code: string): void => {
      if (getCurrencyByCode(code) === undefined) return;
      safeLocalStorage.setItem('preferred-currency', code);
      set({ currency: code });
    },
  }));
